import React from 'react';

function Quote({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M4 10.5C4 8.5 4.5 6 8 6C11.5 6 12 9 12 10.5" />
      <path d="M12 14C12 16 11.5 18.5 8 18.5C4.5 18.5 4 15.5 4 14" />
      <path d="M 4 10.25, v 4" />
      <path d="M 12 10.25, v 4" />
      <path d="M 9.5 15.25, l 3.54 3.54" />
      <path d="M 16.5 11.25, v 5" />
      <path d="M20.5 16.25C20.5 17.1389 20.25 18.25 18.5 18.25C16.75 18.25 16.5 16.9167 16.5 16.25" />
      <path d="M 16.5 13.25, h 2" />
    </svg>
  );
}

export default Quote;
